/**
 * Login Page - Google OAuth Only
 * ===============================
 * Clean, professional login page with Google Sign-in button.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */

import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { Loader2 } from 'lucide-react';

const LoginPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { signInWithGoogle, error } = useAuth();
  const { tr } = useLanguage();

  const handleGoogleSuccess = async (credentialResponse) => {
    setIsLoading(true);
    try {
      await signInWithGoogle(credentialResponse.credential);
    } catch (error) {
      console.error('Google sign-in error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleError = () => {
    console.error('Google sign-in failed');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 via-pink-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-md w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="mx-auto mb-6">
            <video 
              src="https://customer-assets.emergentagent.com/job_whizz-teller/artifacts/tffg3zq7_Blue%20White%20Bold%20Playful%20Kids%20Clothing%20Logo.mp4"
              autoPlay
              loop
              muted
              playsInline
              className="w-20 h-20 object-contain rounded-full shadow-lg mx-auto"
              style={{ 
                maxWidth: '80px',
                maxHeight: '80px',
                minWidth: '80px',
                minHeight: '80px'
              }}
            />
          </div>
          <h1 className="text-4xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-2">
            123zzz
          </h1>
          <p className="text-gray-600">{tr('Magical bedtime stories for your little ones', 'Des histoires du soir magiques pour vos petits')}</p>
        </div>

        {/* Error message */}
        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 text-red-700 rounded-xl text-sm">
            {error}
          </div>
        )}

        {/* Loading state */}
        {isLoading ? (
          <div className="flex items-center justify-center py-4">
            <Loader2 className="w-8 h-8 text-purple-600 animate-spin" />
            <span className="ml-3 text-gray-600">Connecting...</span>
          </div>
        ) : (
          /* Google Sign In Button */
          <div className="flex justify-center">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              theme="outline"
              size="large"
              width="320"
              text="continue_with"
              shape="pill"
            />
          </div>
        )}

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-xs text-gray-400">
            {tr('By signing in, you agree to our Terms of Service and Privacy Policy', "En vous connectant, vous acceptez nos Conditions d'utilisation et notre Politique de confidentialité")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
